import { auth } from "../firebaseConfig";
import { API_BASE_URL } from "./apiBase";

export const LEARNING_CONTENT_API_BASE_URL = API_BASE_URL;

export class LearningContentApiError extends Error {
  constructor(message, status = 0) {
    super(message);
    this.name = "LearningContentApiError";
    this.status = status;
  }
}

const postLearningContent = async (path, body) => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new LearningContentApiError(
      "Please sign in again before saving learning content.",
      401
    );
  }

  const token = await currentUser.getIdToken();
  const response = await fetch(`${LEARNING_CONTENT_API_BASE_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  const responseData = await response.json().catch(() => ({}));
  if (!response.ok || responseData.ok !== true) {
    throw new LearningContentApiError(
      responseData.error || "Learning content could not be saved. Please try again.",
      response.status
    );
  }
  return responseData;
};

export const saveLearningContentApi = (quizId, blocks) =>
  postLearningContent("/api/learning-content/save", { quizId, blocks });

export const clearLearningContentApi = (quizId) =>
  postLearningContent("/api/learning-content/clear", { quizId });
